<script>
import PageTools from "@/components/common/page.vue";
import { formatDate } from "@/utils/date";

export default {
  name: "PostsList",
  components: { PageTools },
  data() {
    return {
      tableData: [],
      total: 0,
      currentPage: 1,
      filters: {
        title: "",
        status: "",
        publish_at: [],
        created_at: [],
      },
    };
  },
  methods: {
    getStatusText(status) {
      const statusMap = {
        0: "待发布",
        1: "已发布",
        2: "定时发布",
      };
      return statusMap[status] || status;
    },
    resetFilters() {
      this.filters = {
        title: "",
        status: "",
        publish_at: [],
        created_at: [],
      };
      this.fetchData(1);
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.postsDelete({ id: row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.fetchData(this.currentPage);
          });
        })
        .catch(() => {});
    },
    handlePublish(row) {
      this.$api.postsPublish({ id: row.id }).then(() => {
        this.$message({
          type: "success",
          message: "发布成功!",
        });
        this.fetchData(this.currentPage);
      });
    },
    fetchData: function (val) {
      const filters = { ...this.filters };

      if (filters.publish_at && filters.publish_at.length === 2) {
        filters.publish_at = [
          formatDate(filters.publish_at[0]),
          formatDate(filters.publish_at[1]),
        ];
      }
      if (filters.created_at && filters.created_at.length === 2) {
        filters.created_at = [
          formatDate(filters.created_at[0]),
          formatDate(filters.created_at[1]),
        ];
      }

      for (const key in filters) {
        if (
          filters[key] === "" ||
          filters[key] === null ||
          (Array.isArray(filters[key]) && filters[key].length === 0)
        ) {
          delete filters[key];
        }
      }
      const params = {
        page: val ? val : 1,
        page_size: 10,
        ...filters,
      };
      this.$api.postsList(params).then((response) => {
        this.tableData = response.data.data;
        this.total = response.data.total;
        this.currentPage = val ? val : 1;
      });
    },
  },
  mounted: function () {
    this.fetchData();
  },
};
</script>

<template>
  <div>
    <div class="filter-container" style="margin-bottom: 20px">
      <el-form :inline="true" :model="filters" class="demo-form-inline">
        <el-form-item label="标题">
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filters.status" placeholder="状态" clearable>
            <el-option label="待发布" value="0"></el-option>
            <el-option label="已发布" value="1"></el-option>
            <el-option label="定时发布" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="filters.publish_at"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filters.created_at"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData(1)">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="title" label="标题" width="180"> </el-table-column>
      <el-table-column prop="desc" label="简介" width="180"> </el-table-column>
      <el-table-column prop="category.name" label="分类"> </el-table-column>
      <el-table-column prop="status" label="状态">
        <template #default="{ row }">
          <span>{{ getStatusText(row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="publish_at" label="发布时间"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间"> </el-table-column>
      <el-table-column label="操作" prop="id" width="200">
        <template #default="{ row }">
          <el-button
            type="text"
            size="small"
            @click="handlePublish(row)"
            v-if="row.status !== 1"
            >发布</el-button
          >
          <el-button type="text" size="small"
            ><router-link :to="`/admin/posts/edit/` + row.id"
              >编辑</router-link
            ></el-button
          >
          <el-button
            type="text"
            size="small"
            style="color: #f56c6c"
            @click="handleDelete(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <PageTools
      :total="this.total"
      :current-page="this.currentPage"
      @page-change="fetchData"
    ></PageTools>
  </div>
</template>

<style scoped>
table th {
  height: 60px; /* 自定义表头高度 */
  vertical-align: middle; /* 垂直居中对齐 */
}
</style>
